import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import moment from "moment/moment";
import { CardContainerRetro } from "../Container/CardContainerRetro";
import { IconEyeFilled } from "@tabler/icons-react";
import { IconAwardFilled } from "@tabler/icons-react";
import MetricStatus from "../MetricStatus/MetricStatus";

export const CardPost = ({
  thread,
  date,
  rd = 8,
  borderType = "full",
  isRemarkable = false,
  isRanked = false,
  rank = 0,
  isMobile,
  isMetric = true,
}) => {
  const theme = useTheme();

  return (
    <CardContainerRetro w={"100%"} rd={rd} borderType={borderType}>
      <Box
        sx={{
          padding: isMobile ? theme.spacing(1, 1.5) : theme.spacing(1.5, 2),
          width: "100%",
          backgroundColor: theme.palette.background.paper,
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(6),
          borderRadius: theme.spacing(0.5),
        }}
      >
        <Stack spacing={0}>
          {isRanked && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 16,
                height: 16,
                borderRadius: "50%",
                backgroundColor: theme.palette.text.primary,
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 700,
                  lineHeight: 1,
                  color: theme.palette.background.paper,
                  fontSize: "0.875rem",
                }}
              >
                {rank}
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              height: 20,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: theme.spacing(0.5),
                alignItems: "center",
              }}
            >
              <Typography
                variant={isMobile ? "body2" : "body1"}
                sx={{
                  fontWeight: 500,
                  lineHeight: 1,
                  color: theme.palette.text.secondary,
                }}
              >
                {moment(date).format("MM/DD")}
              </Typography>
              <Typography
                variant={isMobile ? "body2" : "body1"}
                sx={{
                  fontWeight: 500,
                  lineHeight: 1,
                  color: theme.palette.text.secondary,
                }}
              >
                {moment(date).format("ddd")}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: theme.spacing(0.25),
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              {thread.viewRank < 4 && (
                <IconEyeFilled color={theme.palette.text.primary} size={18} />
              )}
              {(thread.engagementRank < 4 || isRemarkable === true) && (
                <IconAwardFilled color={theme.palette.text.primary} size={18} />
              )}
            </Box>
          </Box>
          <a href={thread.permalink} target="_blank" rel="noreferrer">
            <Typography
              sx={{
                fontFamily:
                  '"source-han-serif-korean", "Noto Serif KR", "Noto Serif CJK KR", "Source Han Serif KR", "Apple SD Gothic Neo", "Malgun Gothic", "맑은 고딕", serif',
                lineHeight: 1.55,
                fontSize: isMobile ? "1rem" : "1.125rem",
                height: isMobile ? 44 : 52,
                fontWeight: 900,
                width: isMobile ? "100%" : "calc(100% - 16px)",
                color: theme.palette.text.primary,
                overflow: "hidden",
              }}
            >
              {thread.text.split(".")[0].replace(/�/g, "")}
            </Typography>
          </a>
        </Stack>
        {isMetric && (
          <Box
            sx={{
              display: "flex",
              gap: isMobile ? 0 : theme.spacing(1),
              color: theme.palette.text.secondary,
              flexWrap: "wrap",
            }}
          >
            <MetricStatus
              w={isMobile ? "50%" : "auto"}
              isMobile={isMobile}
              type={"view"}
              value={thread.views}
            />
            <MetricStatus
              w={isMobile ? "50%" : "auto"}
              isMobile={isMobile}
              type={"like"}
              value={thread.likes}
            />
            <MetricStatus
              w={isMobile ? "50%" : "auto"}
              isMobile={isMobile}
              type={"reply"}
              value={thread.replies}
            />
            <MetricStatus
              w={isMobile ? "50%" : "auto"}
              isMobile={isMobile}
              type={"repost"}
              value={thread.reposts}
            />
          </Box>
        )}
      </Box>
    </CardContainerRetro>
  );
};
